import { isAudiCode, isCarLine } from './utils';
export { isAudiCode, isCarLine };
const getWltpValues = (wltpKeys, vueFormatterService, localeService, logger) => {
    const wltpValuesPromisesKeys = [];
    const wltpValuesPromises = [];
    wltpKeys.forEach((wltpKey) => {
        if (isAudiCode(wltpKey)) {
            wltpValuesPromisesKeys.push(wltpKey);
            wltpValuesPromises.push(vueFormatterService.vueForAudiCode(localeService.countryCode, localeService.language, wltpKey));
        }
        else if (isCarLine(wltpKey)) {
            wltpValuesPromisesKeys.push(wltpKey);
            wltpValuesPromises.push(vueFormatterService.vueRangeForCarline(localeService.countryCode, localeService.language, wltpKey));
        }
        else {
            logger?.error(`Given WltpKey "${wltpKey}" is not a CarLine or an AudiCode!`);
        }
    });
    return { wltpValuesPromises, wltpValuesPromisesKeys };
};
export const getConsumptionsAndEmissions = async (wltpKeys, vueFormatterService, localeService, logger) => {
    const wltpValues = [];
    const { wltpValuesPromises, wltpValuesPromisesKeys } = getWltpValues(wltpKeys, vueFormatterService, localeService, logger);
    await Promise.allSettled(wltpValuesPromises).then((results) => results.forEach((result, index) => {
        if (result.status === 'fulfilled') {
            wltpValues.push(result.value);
        }
        else {
            let errorMessage = '';
            if (isCarLine(wltpValuesPromisesKeys[index])) {
                errorMessage = `Cannot get consumption and emission values for Audi Code "${wltpValuesPromisesKeys[index]}"`;
            }
            else {
                errorMessage = `Cannot get consumption and emission values for CarLine "${wltpValuesPromisesKeys[index]}"`;
            }
            logger?.error(errorMessage, result.reason);
        }
    }));
    return wltpValues;
};
export const getConsumptionsAndEmissionsWithIdentifiers = async (wltpKeys, vueFormatterService, localeService, logger) => {
    const wltpValues = {};
    const { wltpValuesPromises, wltpValuesPromisesKeys } = getWltpValues(wltpKeys, vueFormatterService, localeService, logger);
    await Promise.allSettled(wltpValuesPromises).then((results) => results.forEach((result, index) => {
        if (result.status === 'fulfilled') {
            wltpValues[wltpValuesPromisesKeys[index]] = result.value;
        }
        else {
            let errorMessage = '';
            if (isCarLine(wltpValuesPromisesKeys[index])) {
                errorMessage = `Cannot get consumption and emission values for Audi Code "${wltpValuesPromisesKeys[index]}"`;
            }
            else {
                errorMessage = `Cannot get consumption and emission values for CarLine "${wltpValuesPromisesKeys[index]}"`;
            }
            logger?.error(errorMessage, result.reason);
        }
    }));
    return wltpValues;
};
//# sourceMappingURL=index.js.map